// extracted by mini-css-extract-plugin
export default {"headerContainer":"HeaderWithClose_headerContainer__d7BLH","closeButton":"HeaderWithClose_closeButton__gwVth","logo":"HeaderWithClose_logo__LFMgW"};